import { render } from "./DraggableChip.vue?vue&type=template&id=194d8ac8&scoped=true"
import script from "./DraggableChip.vue?vue&type=script&lang=js"
export * from "./DraggableChip.vue?vue&type=script&lang=js"

import "./DraggableChip.vue?vue&type=style&index=0&id=194d8ac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194d8ac8"]])

export default __exports__